<template>
  <BasicLayout>
    <template #wrapper>
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>打配置</span>
          <el-row :gutter="10" class="mb8" style="margin-top: 20px;">
            <el-col :span="1.5">
              <el-upload
                ref="upload"
                class="upload-demo"
                :action="sys_app_logoAction"
                accept="xlsx"
                :limit="1"
                :on-success="(res)=>{return importProbUploadSuccess(res)}"
                :headers="headers"
              >
                <el-button v-permisaction="['config:attackCoinConfig:import']" :loading="loading" icon="el-icon-upload2" size="mini" type="primary">导入</el-button>
              </el-upload>
            </el-col>

            <el-col :span="1.5">
              <el-button
                v-permisaction="['config:attackCoinConfig:export']"
                type="primary"
                icon="el-icon-download"
                size="mini"
                @click="exportData()"
              >导出</el-button>
            </el-col>

            <el-col :span="1.5">
              <clear-cache-apply />
              <sync-data />
            </el-col>
          </el-row>
        </div>

        <el-table size="mini" :data="formData" border style="width: 70%;min-height: 100px;" highlight-current-row>
          <el-table-column align="center" label="关卡">
            <template slot-scope="{row}">
              <el-input v-model.number="row.levelId" placeholder="关卡" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="有盾金币奖励">
            <template slot-scope="{row}">
              <el-input v-model.number="row.shield" placeholder="有盾金币奖励" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="无盾金币奖励">
            <template slot-scope="{row}">
              <el-input v-model.number="row.no_shield" placeholder="无盾金币奖励" />
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="{row,$index}">
              <el-button v-permisaction="['config:attackCoinConfig:del']" size="mini" type="danger" @click="del($index, row.levelId)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-button v-permisaction="['config:attackCoinConfig:add']" size="mini" type="primary" @click="add()">+</el-button>
        <el-button v-permisaction="['config:attackCoinConfig:add']" size="mini" type="primary" @click="onSubmit()">保存</el-button>

        <pagination
          v-show="total>0"
          background
          :page.sync="queryParams.pageIndex"
          :limit.sync="queryParams.pageSize"
          :total="total"
          @pagination="getTables"
        />
      </el-card>
    </template>
  </BasicLayout>
</template>

<script>
import { getToken } from '@/utils/auth'
import {
  delAttackCoinCfg,
  exportAttackCoinCfg,
  getAttackCoinCfgList,
  importAttackCoinCfg,
  updateAttackCoinCfg
} from '@/api/config/attack-coin-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import SyncData from '@/components/syncData/index.vue'
export default {
  name: 'AttackCoinConfig',
  components: { SyncData, ClearCacheApply },
  data() {
    return {
      loading: false,
      configVisibleArr: [{ visible: false }],
      rewardVisibleArr: [{ visible: false }],
      total: 0,
      headers: { 'Authorization': 'Bearer ' + getToken() },
      sys_app_logoAction: process.env.VUE_APP_BASE_API + '/api/v1/public/uploadFile',
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      formData: [
        {
          'levelId': 0,
          'shield': 0,
          'no_shield': 0
        }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    onSubmit() {
      const data = JSON.stringify(this.formData)
      console.log(data)
      updateAttackCoinCfg({ data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    },
    getTables() {
      getAttackCoinCfgList(this.queryParams).then(res => {
        this.formData = res.data.list
        this.total = res.data.count
      })
    },
    add() {
      this.formData.push({
        'levelId': 0,
        'shield': 0,
        'no_shield': 0
      })
    },
    del(key, id) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delAttackCoinCfg({ id: id }).then(res => {
          if (res.code === 200) {
            this.msgSuccess(res.msg)
            this.getTables()
          } else {
            this.msgError(res.msg)
          }
        })
      })
    },
    exportData() {
      exportAttackCoinCfg().then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    },
    importProbUploadSuccess(response) {
      this.loading = true
      this.$refs.upload.clearFiles()
      importAttackCoinCfg({ data: response.data.path }).then(res => {
        this.loading = false
        // eslint-disable-next-line eqeqeq
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>
</style>
